import React from "react";

import ReactApexChart from "react-apexcharts";
import { Shimmer, ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react/lib/Shimmer';
import PropTypes from 'prop-types';

const AccessesPerMonthTotalPaiAllClients = (props) => {

    const chartData = props.chartData;

    return (  

        <>
          {chartData && 
            <ReactApexChart
              options={{
                chart: {
                  type: 'donut',
                },
                responsive: [{
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 200
                    },
                    legend: {
                      show: false
                    },
                    dataLabels: {
                      enabled: false
                    }
                  }
                }],
                labels: chartData.categoriesPieChart.filter(x => x !== null),
              }}
              series={chartData.seriesPieChart} type="donut" width="100%" height="250px" />
          } 
          {!chartData && 
              <Shimmer
                  customElementsGroup={
                    <div style={{ display: 'flex' }}>
                      <ShimmerElementsGroup
                          shimmerElements={[
                              { type: ShimmerElementType.gap, height: 232 },
                            ]}
                      />
                      <ShimmerElementsGroup
                          shimmerElements={[
                              { type: ShimmerElementType.circle, height: 232 },
                            ]}
                      />
                      <ShimmerElementsGroup
                          flexWrap
                          width="100%"
                          shimmerElements={[
                              { type: ShimmerElementType.gap, width: '50%', height: 58 },
                              { type: ShimmerElementType.line, width: '50%', height: 20 },
                              { type: ShimmerElementType.gap, width: '50%', height: 58 },
                              { type: ShimmerElementType.line, width: '50%', height: 20 },
                              { type: ShimmerElementType.gap, width: '50%', height: 58 },
                              { type: ShimmerElementType.line, width: '50%', height: 20 },
                              { type: ShimmerElementType.gap, width: '50%', height: 58 },
                              { type: ShimmerElementType.line, width: '50%', height: 20 },
                          ]}
                      />
                    </div>
                  }
                  className="pt-4"
                  isDataLoaded={chartData !== null}>
              </Shimmer>
          }
        </>
    );
};
AccessesPerMonthTotalPaiAllClients.propTypes = {
  chartData: PropTypes.object,
};
export default AccessesPerMonthTotalPaiAllClients;